import { render, staticRenderFns } from "./Solutions.vue?vue&type=template&id=7a80b85d&"
import script from "./Solutions.vue?vue&type=script&lang=js&"
export * from "./Solutions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports